import { Dropdown } from "react-bootstrap";


const TitleBarMenuItem = ({children, className="", onClick}) => {

    return(
        <Dropdown.Item as="button" className={"d-flex gap-2"+className} onClick={onClick}>
            {children}
        </Dropdown.Item>
    );
}

export default TitleBarMenuItem;